import type { RouteRecordRaw } from 'vue-router';

export const routes: RouteRecordRaw[] = [
  {
    path: '/:slug/unsubscribe',
    name: 'unsubscribe',
    component: () => import('./pages/UnsubscribePage.vue'),
    meta: { hideBottomNav: true },
  },
];
